<template>
  <div class="content">
    <div class="retain-content">
      <template v-if="errCode">
        <EmptyState emptyType="noNetwork" @tryAgain="handleCancel" />
      </template>
      <template v-else>
        <div class="h5-content">
          <CancelOrderContent>
            <template v-slot:left>
              <div class="img-content">
                <img :src="statusImg" alt="" class="img" />
              </div>
            </template>
            <template v-slot:right>
              <div class="right-cont">
                <div class="info-content">
                  <div class="tit">{{ statusTitle }}</div>
                  <div class="desc">{{ mainBody }}</div>
                </div>
                <Contact
                  :showText="item.info.showText"
                  :title="item.info.title"
                  :desc="item.info.desc"
                  class="concact-cont"
                  :key="'text-link' + index"
                  v-for="(item, index) in showTextLinks"
                >
                  <span slot="showIcon">
                    <i class="icon-outline_phone"></i>
                  </span>
                  <span slot="descIcon">
                    <i class="icon-outline_phone"></i>
                  </span>
                </Contact>
              </div>
            </template>
          </CancelOrderContent>
          <div class="button-content" v-if="showButtons">
            <span v-for="(button, index) in showButtons" :key="index">
              <el-button
                class="btn"
                @click="button.callback"
                :dark="index !== showButtons.length - 1"
                :outline="index !== showButtons.length - 1"
                >{{ button.text }}
              </el-button>
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api';
import { STATUS_MAP, TITLE_MAP, ICON_MAP } from '../const';
import { get, debounce } from 'lodash-es';
import { mapMutations, mapState } from 'vuex';
import { getCustomerServicePhone } from '@/utils/getCountyConfig';
import { Encrypt } from '@/utils/crypto';
import CancelOrderContent from '@/components/CancelOrderContent';
import Contact from '@/components/Contact';
import { ERROR_CODE, REFRESH_TIME } from '../const';
import EmptyState from '@/components/EmptyState';
import { errImgBase64 } from '@/directives/imgError/conf';

const VIRTUAL_PHONE_ROLE_TYPE = {
  RIDER: 0,
  MERCHAT: 1,
};
const TRACK_CONNET_BUTTON_TYPE = {
  CONTACT_MERCHAT: 1,
  CONTACT_RIDER: 2,
  WAIT: 3,
  CANCEL_ORDER: 4, // 取消订单
  CONTACT_CUSTOMER_SERVICE: 5,
  SUBMIT: 6, // 提交申请
};

const TRACK_CONFIRM_BUTTON_TYPE = {
  NO_CANCEL: 0, // 暂不取消
  CANCEL: 1, // 取消
};
export default {
  name: 'cancelOrderRetain', // 取消订单挽留页面
  components: {
    CancelOrderContent,
    Contact,
    EmptyState,
  },
  data() {
    return {
      merchatPhone: '',
      riderPhone: '',
      loading: false,
      buttonData: {
        funcApplyToB: {
          callback: this.applyCancel,
          text: this.$t('提交申请'),
        },
        funcConfirm: {
          callback: this.cancelOrder,
          text: this.$t('取消订单'),
        },
        funcWaitAgain: {
          callback: this.keepWaiting,
          text: this.$t('再等等'),
        },
      },
      errCode: null,
    };
  },
  props: {
    cancelData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      selfInfo: ({ common }) => common.sidebar.selfInfo,
    }),
    userPhone() {
      return get(this, 'selfInfo.phone', null);
    },
    callingCode() {
      return get(this, 'selfInfo.callingCode', null);
    },
    statusImg() {
      return get(ICON_MAP, this.currentStatusName, errImgBase64);
    },
    statusTitle() {
      return get(TITLE_MAP, this.currentStatusName, '');
    },
    mainBody() {
      return get(this, 'cancelData.content.mainBody', '');
    },
    currentStatusName() {
      let statusName = '';
      const cancelData = get(this, 'cancelData', null);
      if (cancelData) {
        const order_status = get(cancelData, 'order_status', null);
        const applyProcess = get(cancelData, 'applyProcess', null);
        const bussiness_mode = get(cancelData, 'bussiness_mode', null);
        if (+order_status === 200 && applyProcess) {
          statusName = get(STATUS_MAP, order_status * 10 + applyProcess, '');
          // 代购
        } else if (+bussiness_mode === 300 && +order_status === 140) {
          statusName = get(STATUS_MAP, order_status * 10, '');
        } else {
          statusName = get(STATUS_MAP, order_status, '');
        }
      }
      return statusName;
    },
    popText() {
      const popTxt = get(this, 'cancelData.content.popText', '{}');
      return JSON.parse(popTxt);
    },
    showTips() {
      return !!get(this, 'cancelData.content.tips', null);
    },
    showButtons() {
      const buttons = get(this, 'cancelData.buttons', []);
      const showButtons = [];
      for (let btnKey in this.buttonData) {
        if (buttons[btnKey]) {
          showButtons.push(this.buttonData[btnKey]);
        }
      }
      return showButtons;
    },
    showTextLinkData() {
      return {
        funcContactD: {
          callback: this.contactRider,
          info: {
            showText: this.$t('联系骑手'),
            desc: this.riderPhone,
          },
        },
        funcContactB: {
          callback: this.contactShop,
          info: {
            showText: this.$t('联系商家'),
            desc: this.merchatPhone,
          },
        },
        funcContactP: {
          info: {
            showText: this.$t('联系客服'),
            desc: this.customerServicePhone,
          },
        },
      };
    },
    showTextLinks() {
      const buttons = get(this, 'cancelData.buttons', []);
      const showLinks = [];
      for (let btnKey in this.showTextLinkData) {
        if (buttons[btnKey]) {
          const linkObj = get(this, `showTextLinkData.${btnKey}`, {});
          if (linkObj.callback) {
            linkObj.callback();
          }
          showLinks.push(linkObj);
        }
      }
      return showLinks;
    },
    customerServicePhone() {
      const csTelNumber = getCustomerServicePhone();
      return csTelNumber;
    },
  },
  methods: {
    ...mapMutations('afterSales', ['updateCancelOrderInfo']),
    async getVirtualPhone(params) {
      const orderId = get(this, '$route.query.orderId', null);
      const defaultParams = {
        orderId,
        phone: Encrypt(this.userPhone),
        callingCode: this.callingCode,
      };
      const res = await api.getVirtualtelCall(
        Object.assign(defaultParams, params)
      );
      return res;
    },
    // 获取骑手电话
    async getRiderNumber() {
      const res = await this.getVirtualPhone({
        role: VIRTUAL_PHONE_ROLE_TYPE.RIDER,
      });
      this.riderPhone = get(res, 'virtualPhone', '');
    },
    async getMerchatNumber() {
      const res = await this.getVirtualPhone({
        role: VIRTUAL_PHONE_ROLE_TYPE.MERCHAT,
      });
      this.merchatPhone = get(res, 'virtualPhone', '');
    },
    // 联系骑手
    async contactRider() {
      // 骑手电话获取方法
      await this.getRiderNumber();
    },
    // 联系商家
    async contactShop() {
      // 骑手电话获取方法
      await this.getMerchatNumber();
    },
    // 再等等
    keepWaiting() {
      this.goOrderDetail();
      this.cancelOrderConnectTrack(TRACK_CONNET_BUTTON_TYPE.WAIT);
    },
    // 跳转订单详情页面
    goOrderDetail() {
      const orderId = get(this, '$route.query.orderId', null);
      if (!orderId) return;
      this.$router.push({
        path: '/orderDetail/',
        query: {
          orderId,
        },
      });
    },
    // 确定取消
    cancelOrder: debounce(function () {
      if (get(this, 'cancelData.content.popFlag', null)) {
        const title = get(this, 'popText.popTitle', '');
        const content = get(this, 'popText.popContent', '');
        this.$rconfirm(content, title, {
          confirmButtonText: this.$t('确认'),
          cancelButtonText: this.$t('取消'),
        })
          .then(() => {
            this.handleCancel();
            this.cancelOrderConfirmTrack(TRACK_CONFIRM_BUTTON_TYPE.CANCEL);
          })
          .catch(() => {
            this.cancelOrderConfirmTrack(TRACK_CONFIRM_BUTTON_TYPE.NO_CANCEL);
          });
      } else {
        this.handleCancel();
      }
      this.cancelOrderConnectTrack(TRACK_CONNET_BUTTON_TYPE.CANCEL_ORDER);
    }, 300),
    // 确定取消
    handleCancel: debounce(async function () {
      try {
        const orderStatus = get(this, 'cancelData.order_status', '');
        this.loading = true;
        const res =
          (await api.cancelOrder({
            orderId: this.$route.query.orderId,
            paymentError: this.$route.query.paymentError,
          })) || {};
        this.errCode = null;
        this.loading = false;
        setTimeout(() => {
          this.$router.replace({
            // 如果是向商家申请过，则无需填写取消订单原因，直接跳转至结果页面
            name:
              this.cancelData.applyProcess > 0
                ? 'CancelOrderResult'
                : 'CancelOrderReason',
            query: {
              ...Object.assign(this.$route.query, {
                orderStatus,
                judgeId: get(res, 'judgeId', null),
                cancelSuccessText: res.cancelSuccessText,
                cancelSuccessTips: res.cancelSuccessTips,
              }),
            }, // judgeId参数为管控api需要，不要删除
          });
        }, 200);
      } catch (error) {
        this.errCode = null;
        const errno = get(error, 'errno', null);
        // 关闭订单已完成页面
        if (+errno === ERROR_CODE.ORDER_STATUS_UPDATE) {
          this.goOrderList();
        } else if (+errno === ERROR_CODE.INFO_UPDATE) {
          setTimeout(() => {
            this.handleCancel();
          }, REFRESH_TIME);
        } else {
          this.errCode = errno;
          this.loading = false;
        }
      }
    }, 300),
    // 提交申请
    async applyCancel() {
      setTimeout(() => {
        this.goCancelOrderReason();
      }, 200);
      this.cancelOrderConnectTrack(TRACK_CONNET_BUTTON_TYPE.SUBMIT);
    },
    // 跳转取消订单选择理由
    goCancelOrderReason() {
      const orderStatus = get(this, 'cancelData.order_status', '');
      this.$router.push({
        name: 'CancelOrderReason',
        query: {
          ...Object.assign(this.$route.query, {
            orderStatus,
            type: 'applyCancel',
          }),
        },
      });
    },
    goOrderList() {
      this.$router.push({
        path: '/order/',
      });
    },
    cancelOrderConnectTrack(buttonType) {
      const orderId = get(this, '$route.query.orderId', '');
      const orderStatus = get(this, 'cancelData.order_status', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_cancelorder_connect_ck',
        eventLabel: '取消订单页用户行为点击',
        attrs: {
          order_id: orderId,
          order_status: orderStatus,
          button_type: buttonType,
        },
      });
    },
    cancelOrderConfirmTrack(buttonType) {
      const orderId = get(this, '$route.query.orderId', '');
      const orderStatus = get(this, 'cancelData.order_status', '');
      this.$trackEvent({
        eventId: 'sailing_c_x_cancelorder_comfirm_ck',
        eventLabel: '取消订单页点击暂不取消或者确定取消',
        attrs: {
          order_id: orderId,
          order_status: orderStatus,
          button_type: buttonType,
        },
      });
    },
  },
};
</script>
<style lang="scss">
@import '../../control_global.scss';
// 移动端适配
@media screen and (max-width: 768px) {
  .retain-content {
    .cancel-order-content {
      background: #fff;
      .left {
        min-height: 0;
        width: auto;
      }
      .right {
        padding: 0 rem(40);
      }
    }
  }
}
</style>
<style lang="scss" scoped>
@import '../../control_global.scss';
.content {
  height: calc(100vh - #{$pc_cont_height});
  position: relative;
  max-width: 940px;
  margin: 0 auto;
  padding-bottom: 80px;
}
.button-content {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: right;
  height: 80px;
  padding-right: 20px;
  background: #ffffff;
  .btn {
    margin: 20px 0 20px 20px;
    min-width: $pc_button_min_width;
  }
}
.img-content {
  width: 250px;
  height: auto;
  margin: 80px auto 0;
  .img {
    width: 100%;
    height: 100%;
  }
}
.retain-content {
  height: 100%;
  background: #fff;
  border-radius: 8px;
  overflow-y: auto;
  .info-content {
    flex: 1;
    position: relative;
    overflow-y: auto;
    .tit {
      margin-top: 40px;
      margin-bottom: 20px;
      font-family: 'Aspira Medium';
      font-size: 24px;
      line-height: 28px;
      color: #000000;
    }
    .desc {
      font-family: 'Aspira Light';
      font-size: 14px;
      line-height: 18px;
      color: #000000;
      margin-bottom: 24px;
      margin: 0 auto 20px;
    }
    .tit,
    .desc {
      max-width: 500px;
      margin-left: auto;
      margin-right: auto;
    }
  }
  .concact-cont {
    margin-bottom: 24px;
  }
  .icon-outline_phone {
    vertical-align: middle;
  }
}
// 移动端适配
@media screen and (max-width: 768px) {
  .h5-content {
    display: flex;
    height: auto;
    flex-direction: column;
    .cancel-order-content {
      flex: 1;
      overflow-y: auto;
    }
  }
  .content {
    height: auto;
    min-height: calc(100vh - #{$h5_retain_button_cont_height});
    padding: 0 0 $h5_retain_button_cont_height;
    background: #fff;
    margin: 0;
  }
  .retain-content {
    background: #fff;
    height: auto;
    margin-bottom: 0;
    overflow-y: inherit;
    .img-content {
      width: 100%;
      height: 100%;
      margin-top: 0;
      margin-left: 0;
      padding: rem(48) rem(160) rem(0);
    }
    .img {
      width: 100%;
      height: 100%;
    }

    .info-content {
      .tit {
        margin-top: rem(62);
        margin-bottom: rem(24);
        font-family: 'Aspira Medium';
        font-size: rem(48);
        line-height: rem(56);
        color: #000000;
        text-align: left;
      }
      .desc {
        font-family: 'Aspira Light';
        font-size: rem(32);
        line-height: rem(38);
        color: #000000;
        margin-bottom: rem(40);
        text-align: left;
      }
    }
    .concact-cont {
      text-align: left;
      margin-bottom: rem(96);
      line-height: rem(36);
    }

    .button-content {
      position: fixed;
      bottom: 0;
      padding: 0 rem(24) 0;
      height: auto;
      display: flex;
      flex-direction: column-reverse;
      .btn {
        height: $h5_normal_button_height;
        width: 100%;
        display: block;
        margin: 0 0 rem(40);
      }
    }
    .icon-outline_phone {
      vertical-align: middle;
    }
  }
}
</style>
